/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ShellPersistenceKey {
  static readonly IS_SIDEBAR_VISIBLE = 'shell/persistence/is-sidebar-visible';
}
